import { Stack, Typography } from "@mui/material";
import { TableColumnType, TierMapper } from "../../types/genereal";
import { TierType } from "../../types/enums";
import { RecommendedListRow } from "./RecommendedListRow";
import { RecommendedAccount } from "../../types/apiTypes";
import { useRef, useState } from "react";
import { ShowAllAccountsBlock } from "./ShowAllAccountsBlock";

const demoList = [
  {
    id: "1",
    campaign_id: "1",
    name: "--",
    industry: "--",
    region: "--",
    size: "--",
    revenue: "--",
    tier: TierType.medium,
    reason: "--",
  },
  {
    id: "2",
    campaign_id: "1",
    name: "--",
    industry: "--",
    region: "--",
    size: "--",
    revenue: "--",
    tier: TierType.medium,
    reason: "--",
  },
  {
    id: "3",
    campaign_id: "1",
    name: "--",
    industry: "--",
    region: "--",
    size: "--",
    revenue: "--",
    tier: TierType.medium,
    reason: "--",
  },
];

type Props = {
  tier: TierType;
  recommendedAccounts: RecommendedAccount[];
  columns: TableColumnType[];
  isDemo: boolean;
};

export const RecommendedListBlock = ({
  tier,
  recommendedAccounts,
  columns,
  isDemo,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  const { label, title, color } = TierMapper[tier];

  if (recommendedAccounts.length === 0 && !isDemo) return null;
  return (
    <Stack
      sx={{
        flexDirection: "row",
        width: "100%",
      }}
    >
      <Stack
        flexGrow={1}
        sx={{
          padding: "8px 0",
          borderBottom: "1px solid #DEDEDE",
        }}
      >
        <Stack
          flexGrow={1}
          sx={{
            minWidth: columns[0].minWidth,
            maxWidth: columns[0].maxWidth,
            borderRight: isDemo ? "none" : `4px solid ${color}`,
            gap: "16px",
            paddingLeft: "16px",
            alignItems: "flex-start",
          }}
        >
          {!isDemo && (
            <>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "19px",
                  color: color,
                }}
              >
                {label}
                <br />
                {title}
              </Typography>
              {recommendedAccounts.length > 3 && (
                <ShowAllAccountsBlock
                  isExpanded={isExpanded}
                  total={recommendedAccounts.length}
                  expandHandler={() => setIsExpanded((prev) => !prev)}
                />
              )}
            </>
          )}
        </Stack>
      </Stack>
      <Stack
        ref={ref}
        sx={{
          width: "100%",
          maxHeight: isExpanded ? undefined : "165px",
        }}
      >
        {(isDemo ? demoList : recommendedAccounts)
          .slice(0, isExpanded ? undefined : 3)
          .map((account) => (
            <RecommendedListRow
              key={account.id}
              row={account}
              columns={columns}
              isDemo={isDemo}
            />
          ))}
      </Stack>
    </Stack>
  );
};
